<form id="records-form-pg-1" [formGroup]="recordsFormGroup">
  <!-- Code Implementation for Records Information -->
  <div formArrayName="records">
    <p-panel
      header="Add Provider"
      styleClass="mb-3 panel-bg-color border"
      *ngFor="let record of records.controls; let i = index"
      [formGroupName]="i"
      [ngClass]="{ 'mt-2rem panel-bg-color': i > 0 }"
    >
      <div>
        <div
          class="border-bottom-dotted d-flex justify-content-between align-items-center py-2 px-3"
        >
          <h2 class="recordListNo mb-0">
            <span>Add Provider</span>
          </h2>
        </div>
      </div>

      <div class="p-3">
        <div class="row mb-3" *ngIf="isSearchProviderEnabled">
            <div class="col-12">
                <app-contact-search (onSelect)="onContactSelect($event, i)"></app-contact-search>
            </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
            <label
              for="record-provider-name"
              class="form-label d-block required-asterisk"
              >Provider (Institution)</label
            >
            <input
              pInputText
              type="text"
              id="record-provider-name"
              class="w-100"
              placeholder="Enter provider (institution)"
              formControlName="providerName"
              [ngClass]="{
                'ng-invalid ng-dirty': isError('providerName', record)
              }"
            />
            <small
              id="record-provider-name-error"
              *ngIf="isError('providerName', record)"
              class="error-label"
              >This field is mandatory</small
            >
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
            <label for="record-doctor" class="form-label d-block">Doctor</label>
            <input
              pInputText
              type="text"
              id="record-doctor"
              class="w-100"
              placeholder="Enter doctor"
              formControlName="doctor"
              [ngClass]="{ 'ng-invalid ng-dirty': isError('doctor', record) }"
            />
            <small
              id="record-doctor-error"
              *ngIf="isError('doctor', record)"
              class="error-label"
              >This field is mandatory</small
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
            <label for="record-street-address" class="form-label d-block"
              >Street Address</label
            >
            <input
              pInputText
              type="text"
              id="record-street-address"
              class="w-100"
              placeholder="Enter street address"
              formControlName="streetAddress"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
            <label for="record-apt-suite-other" class="form-label d-block"
              >Apt/Suite/other</label
            >
            <input
              pInputText
              type="text"
              id="record-apt-suite-other"
              class="w-100"
              placeholder="Enter apt/suite/other"
              formControlName="aptSuiteOther"
            />
          </div>         
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
            <label for="record-state" class="form-label d-block">State</label>
            <p-select
              formControlName="stateName"
              id="record-state"
              [options]="states"
              optionLabel="name"
              placeholder="Select state"
              styleClass="w-100"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
            <label for="record-city-name" class="form-label d-block"
              >City</label
            >
            <input
              pInputText
              type="text"
              id="record-city-name"
              class="w-100"
              placeholder="Enter city"
              formControlName="cityName"
            />
          </div>
        </div>
        <div class="row">          
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
            <label for="record-zip" class="form-label d-block">Zip</label>
            <input
              pInputText
              type="text"
              id="record-zip"
              class="w-100"
              placeholder="Enter zip"
              formControlName="zipCode"
            />
          </div>
          <div class="col-8 col-md-4 col-lg-2 mb-3 mb-sm-0 pe-1">
            <label for="record-phone-{{i}}" class="form-label d-block">Phone</label>
            <p-inputmask mask="(999) 999-9999" type="text" id="record-phone-{{i}}" class="w-100 phone-inputmask" placeholder="Enter phone"
              formControlName="phone" autocomplete="new-password"/>
          </div>
          <div class="col-4 col-md-2 col-lg-1 mb-3 mb-sm-0 ps-1">
            <label for="record-phone-extn-{{i}}" class="form-label d-block">Extension</label>
            <input pInputText type="text" id="record-phone-extn-{{i}}" placeholder="Enter" formControlName="extn"
              class="w-100" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
              <label for="record-fax-{{i}}" class="form-label d-block">Fax</label>
              <input pInputText type="text" id="record-fax-{{i}}" class="w-100" placeholder="Enter fax"
          formControlName="fax" />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
              <label for="record-email-{{i}}" class="form-label d-block">Email</label>
              <input pInputText type="text" id="record-email-{{i}}" class="w-100" placeholder="Enter email"
                  formControlName="email" />
              <small *ngIf="record.get('email')?.hasError('email')" class="error-label">Please
                  enter a valid email address.</small>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
            <label
              for="record-subject"
              class="form-label d-block required-asterisk"
              >Record Subject</label
            >
            <p-dropdown
              [options]="subjectNames"
              formControlName="subject"
              id="record-subject"
              placeholder="Select record subject"
              styleClass="w-100"
              [ngClass]="{ 'ng-invalid ng-dirty': isError('subject', record) }"
              (onChange)="onRecordSubjectChange(record, i)"
            />
            <small
              id="record-subject-error"
              *ngIf="isError('subject', record)"
              class="error-label"
              >This field is mandatory</small
            >
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
            <label for="record-range" class="form-label d-block"
              >Record Range</label
            >
            <p-checkbox
              formControlName="range"
              inputId="record-range-label-label"
              value="anyorall"
              id="record-range"
              (onChange)="toggleAllImagingTypes(record)"
            />
            <label for="record-range-label-label" class="ms-2 mt-2"
              >Any or All</label
            >
          </div>
          <div
            class="col-sm-12 col-md-6 col-lg-3 mb-3"
            *ngIf="record.value.range.length <= 0"
          >
            <label
              for="date-of-date-to-serviceFrom"
              class="form-label d-block required-asterisk"
              >Date to service from</label
            >
            <p-datepicker
              dateMask
              inputId="date-of-date-to-serviceFrom"
              placeholder="mm/dd/yyyy"
              showIcon
              iconDisplay="input"
              styleClass="w-100"
              [maxDate]="maxDate"
              formControlName="dateToServiceFrom"
              [ngClass]="{
                'ng-invalid ng-dirty': isError('dateToServiceFrom', record)
              }"
              appendTo="body"
              (onInput)="onDateChange($event, i, 'serviceFromDate')"
            />
            <small
              id="date-to-serviceFrom-error"
              *ngIf="isError('dateToServiceFrom', record) && !record.get('dateToServiceFrom')?.errors?.['maxDateExceeded']"
              class="error-label"
              >This field is mandatory</small
            >
            <small 
              id="date-to-serviceFrom-error" 
              *ngIf="record.get('dateToServiceFrom')?.errors?.['maxDateExceeded']" 
              class="error-label">Please enter a valid date</small>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="record.value.range <= 0">
            <label
              for="date-of-date-to-serviceTo"
              class="form-label d-block required-asterisk"
              >Date to service to</label
            >
            <p-datepicker
              dateMask
              inputId="date-of-date-to-serviceTo"
              placeholder="mm/dd/yyyy"
              showIcon
              iconDisplay="input"
              styleClass="w-100"
              [maxDate]="maxDate"
              formControlName="dateToServiceTo"
              [ngClass]="{
                'ng-invalid ng-dirty': isError('dateToServiceTo', record)
              }"
              appendTo="body"
              (onInput)="onDateChange($event, i, 'serviceToDate')"
            />
            <small
              id="date-to-serviceTo-error"
              *ngIf="
                isError('dateToServiceTo', record) &&
                !record.get('dateToServiceTo')?.hasError('invalidDateRange') &&
                !record.get('dateToServiceTo')?.errors?.['maxDateExceeded']
              "
              class="error-label"
              >This field is mandatory</small
            >
            <small
              id="date-to-serviceFrom-error"
              *ngIf="
                isError('dateToServiceTo', record) &&
                record.get('dateToServiceTo')?.hasError('invalidDateRange') &&
                !record.get('dateToServiceTo')?.errors?.['maxDateExceeded']
              "
              class="error-label"
              >'Date to service to' should not be earlier than 'Date to service
              from'</small
            >
            <small id="date-to-serviceTo-error" *ngIf="record.get('dateToServiceTo')?.errors?.['maxDateExceeded']" class="error-label">Please enter a valid date</small>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <label
              for="record-range"
              class="form-label d-block required-asterisk"
              >Record Type Requested</label
            >
          </div>
        </div>
        <div class="row mb-3">
          <div
            class="col-sm-3 mb-1 mb-sm-0"
            *ngFor="let type of requestedRecordTypes"
          >
            <p-checkbox
              [value]="type.key"
              formControlName="selectedTypes"
              inputId="record-{{ type.key }}-checkbox-label"
              (onChange)="onSelectRequestedRecord($event, type.name, record)"
              id="record-{{ type.key }}-checkbox"
              [ngClass]="{
                'ng-invalid ng-dirty': isError('selectedTypes', record)
              }"
            />
            <label
              for="record-{{ type.key }}-checkbox-label"
              class="ms-2 mt-2"
              >{{ type.name }}</label
            >
          </div>
          <small
            id="selectedTypes-error"
            *ngIf="isError('selectedTypes', record)"
            class="error-label"
            >This field is mandatory</small
          >
        </div>
        <ng-container *ngIf="showAdditionalDetails(record)">
          <label class="form-label d-block"
            >Please provide additional details.</label
          >
          <p-card>
            <ng-container *ngIf="checkRecordType(record, 'diagnostic-images')">
              <div formGroupName="diagnosticImages">
                <div class="row mb-0">
                  <div class="col-sm-12 mb-3 mb-sm-0">
                    <label class="form-label d-block">Type of Imaging</label>
                  </div>
                  <div class="row mb-0 mb-lg-3">
                    <div
                      class="col-auto mb-3 mb-sm-0 records-imaging-type"
                      *ngFor="let type of typesOfImaging; let i = index"
                    >
                      <p-checkbox
                        formControlName="typesOfImaging"
                        [value]="type"
                        id="type-of-imaging-checkbox-{{ i }}"
                        inputId="type-of-imaging-checkbox-label-{{ i }}-label"
                        (onChange)="onTypeChange(record, type, $event)"
                      />
                      <label
                        for="type-of-imaging-checkbox-label-{{ i }}-label"
                        class="ms-2"
                        >{{ type.name }}</label
                      >
                    </div>
                  </div>
                  <div
                    class="row mb-0 mb-lg-3"
                    *ngIf="isOtherImagingTypeSelected(record)"
                  >
                    <div class="col-sm-12">
                      <label
                        for="record-type-other"
                        class="form-label required-asterisk"
                        >Other (please specify)</label
                      >
                      <input
                        pInputText
                        type="text"
                        id="record-type-other"
                        class="w-100"
                        placeholder="Enter here..."
                        formControlName="other"
                        [ngClass]="{
                          'ng-invalid ng-dirty': isError(
                            'diagnosticImages',
                            record
                          )
                        }"
                      />
                      <small
                        id="record-type-othe-error"
                        *ngIf="isError('diagnosticImages', record)"
                        class="error-label"
                        >This field is mandatory</small
                      >
                    </div>
                  </div>
                  <div class="row mb-0 mb-lg-3">
                    <div class="col-sm-12">
                      <label for="record-type-body-part" class="form-label"
                        >Specific Body Part/Area (if applicable)</label
                      >
                      <input
                        pInputText
                        type="text"
                        id="record-type-body-part"
                        class="w-100"
                        placeholder="Enter here..."
                        formControlName="specificBodyPart"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- </p-card> -->
            </ng-container>

            <ng-container *ngIf="checkRecordType(record, 'social-security')">
              <!-- <p-card> -->
              <div
                formGroupName="socialSecurity"
                class="selected-record-container"
              >
                <label class="form-label bold-text">Social Security</label>
                <div class="row mb-0 mb-lg-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="ss" class="form-label required-asterisk"
                      >SS#</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="ss"
                      class="w-100"
                      placeholder="Enter SS#"
                      formControlName="socialSecuritySS"
                      [ngClass]="{
                        'ng-invalid ng-dirty': isError(
                          'socialSecurity.socialSecuritySS',
                          record
                        )
                      }"
                    />
                    <small
                      id="socialSecuritySS-error"
                      *ngIf="isError('socialSecurity.socialSecuritySS', record)"
                      class="error-label"
                      >This field is mandatory</small
                    >
                    <small
                      *ngIf="
                        checkSubjectMismatchError(
                          record.get('subject')?.value
                        ) && !isError('socialSecurity.socialSecuritySS', record)
                      "
                      class="error-label"
                    >
                      The SS# values for record subject
                      {{ record.get("subject")?.value }} should match
                    </small>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label
                      for="securty-address"
                      class="form-label required-asterisk"
                      >Street Address (Record Subject)</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="securty-address"
                      class="w-100"
                      placeholder="Enter street address"
                      formControlName="address"
                      [ngClass]="{
                        'ng-invalid ng-dirty': isError(
                          'socialSecurity.address',
                          record
                        )
                      }"
                    />
                    <small
                      id="address-error"
                      *ngIf="isError('socialSecurity.address', record)"
                      class="error-label"
                      >This field is mandatory</small
                    >
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label
                      for="securty-address-city"
                      class="form-label required-asterisk"
                      >City</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="securty-address-city"
                      class="w-100"
                      placeholder="Enter city"
                      formControlName="city"
                      [ngClass]="{
                        'ng-invalid ng-dirty': isError(
                          'socialSecurity.city',
                          record
                        )
                      }"
                    />
                    <small
                      id="city-error"
                      *ngIf="isError('socialSecurity.city', record)"
                      class="error-label"
                      >This field is mandatory</small
                    >
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label
                      for="securty-address-state"
                      class="form-label required-asterisk"
                      >State</label
                    >
                    <p-select
                      id="securty-address-state"
                      [options]="states"
                      optionLabel="name"
                      placeholder="Select state"
                      styleClass="w-100"
                      formControlName="state"
                      [ngClass]="{
                        'ng-invalid ng-dirty': isError(
                          'socialSecurity.state',
                          record
                        )
                      }"
                    />
                    <small
                      id="state-error"
                      *ngIf="isError('socialSecurity.state', record)"
                      class="error-label"
                      >This field is mandatory</small
                    >
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label
                      for="securty-address-zip required-asterisk"
                      class="form-label d-block"
                      >Zip</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="securty-address-zip"
                      class="w-100"
                      placeholder="Enter zip"
                      formControlName="zip"
                      [ngClass]="{
                        'ng-invalid ng-dirty': isError(
                          'socialSecurity.zip',
                          record
                        )
                      }"
                    />
                    <small
                      id="zip-error"
                      *ngIf="isError('socialSecurity.zip', record)"
                      class="error-label"
                      >This field is mandatory</small
                    >
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="checkRecordType(record, 'ambulance')">
              <div formGroupName="ambulance">
                <label class="form-label d-block">Ambulance</label>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label
                      for="date-of-ambulance-service"
                      class="form-label d-block required-asterisk"
                      >Date of Ambulance Service</label
                    >
                    <p-datepicker
                      dateMask
                      inputId="date-of-ambulance-service"
                      placeholder="mm/dd/yyyy"
                      showIcon
                      iconDisplay="input"
                      styleClass="w-100"
                      formControlName="date"
                      [maxDate]="maxDate"
                      [ngClass]="{
                        'ng-invalid ng-dirty': isError('ambulance', record)
                      }"
                      appendTo="body"
                      (onInput)="onDateChange($event, i, 'ambulanceServiceDate')"
                    />
                    <small
                      id="date-of-ambulance-service-error"
                      *ngIf="isError('ambulance', record) && !record.get('ambulance.date')?.errors?.['maxDateExceeded']"
                      class="error-label"
                      >This field is mandatory</small
                    >
                    <small 
                      id="date-of-ambulance-service-error" 
                      *ngIf="record.get('ambulance.date')?.errors?.['maxDateExceeded']" 
                      class="error-label">Please enter a valid date</small>
                    
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label
                      for="time-of-ambulance-service"
                      class="form-label d-block"
                      >Time of Ambulance Service</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="time-of-ambulance-service"
                      class="w-100"
                      placeholder="Enter time"
                      formControlName="time"
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label
                      for="street-address-pickup"
                      class="form-label d-block"
                      >Street Address (Pickup)</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="street-address-pickup"
                      class="w-100"
                      placeholder="Enter street address"
                      formControlName="pickupAddress"
                    />
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="pickup-city" class="form-label d-block"
                      >City</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="pickup-city"
                      class="w-100"
                      placeholder="Enter city"
                      formControlName="pickupCity"
                    />
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="pickup-state" class="form-label d-block"
                      >State</label
                    >
                    <p-select
                      id="pickup-state"
                      [options]="states"
                      optionLabel="name"
                      placeholder="Select state"
                      styleClass="w-100"
                      formControlName="pickupState"
                    />
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="pickup-zip" class="form-label d-block"
                      >Zip</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="pickup-zip"
                      class="w-100"
                      placeholder="Enter zip"
                      formControlName="pickupZip"
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="street-address-drop" class="form-label d-block"
                      >Street Address (Drop)</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="street-address-drop"
                      class="w-100"
                      placeholder="Enter street address"
                      formControlName="dropAddress"
                    />
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="drop-city" class="form-label d-block"
                      >City</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="drop-city"
                      class="w-100"
                      placeholder="Enter city"
                      formControlName="dropCity"
                    />
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="drop-state" class="form-label d-block"
                      >State</label
                    >
                    <p-select
                      id="drop-state"
                      [options]="states"
                      optionLabel="name"
                      placeholder="Select state"
                      styleClass="w-100"
                      formControlName="dropState"
                    />
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="drop-zip" class="form-label d-block">Zip</label>
                    <input
                      pInputText
                      type="text"
                      id="drop-zip"
                      class="w-100"
                      placeholder="Enter zip"
                      formControlName="dropZip"
                    />
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="checkRecordType(record, 'insurance')">
              <div formGroupName="insurance">
                <label class="form-label d-block">Insurance</label>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label
                      for="claim-number"
                      class="form-label d-block required-asterisk"
                      >Claim Number</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="claim-number"
                      class="w-100"
                      placeholder="Enter claim number"
                      formControlName="claimNumber"
                      [ngClass]="{
                        'ng-invalid ng-dirty': isError('insurance', record)
                      }"
                    />
                    <small
                      id="claim-number-service-error"
                      *ngIf="isError('insurance', record)"
                      class="error-label"
                      >This field is mandatory</small
                    >
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="policy-number" class="form-label d-block"
                      >Enter Policy Number</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="policy-number"
                      class="w-100"
                      placeholder="Enter policy number"
                      formControlName="policyNumber"
                    />
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="checkRecordType(record, 'employment')">
              <div formGroupName="employment">
                <label class="form-label d-block">Employment</label>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="ss" class="form-label d-block required-asterisk"
                      >SS#</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="ss"
                      class="w-100"
                      placeholder="Enter SS#"
                      formControlName="employmentSS"
                      [ngClass]="{
                        'ng-invalid ng-dirty': isError('employment', record)
                      }"
                    />
                    <small
                      id="employmentSS-error"
                      *ngIf="isError('employment', record)"
                      class="error-label"
                      >This field is mandatory</small
                    >
                    <small
                      *ngIf="
                        checkSubjectMismatchError(
                          record.get('subject')?.value
                        ) && !isError('employment', record)
                      "
                      class="error-label"
                    >
                      The SS# values for record subject
                      {{ record.get("subject")?.value }} should match
                    </small>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="checkRecordType(record, 'military')">
              <div formGroupName="military">
                <label class="form-label d-block">Military</label>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="branch" class="form-label d-block"
                      >Branch (if known)</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="branch"
                      class="w-100"
                      placeholder="Enter branch"
                      formControlName="branch"
                    />
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="service-number" class="form-label d-block"
                      >Service Number (if known)</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="service-number"
                      class="w-100"
                      placeholder="Enter service number"
                      formControlName="serviceNumber"
                    />
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="checkRecordType(record, 'irs')">
              <div formGroupName="irs">
                <label class="form-label d-block">IRS</label>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="ss" class="form-label d-block required-asterisk"
                      >SS#</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="ss"
                      class="w-100"
                      formControlName="irsSS"
                      [ngClass]="{
                        'ng-invalid ng-dirty': isError('irs', record)
                      }"
                      placeholder="Enter SS#"
                    />
                    <small
                      id="irsSS-error"
                      *ngIf="isError('irs', record)"
                      class="error-label"
                      >This field is mandatory</small
                    >
                    <small
                      *ngIf="
                        checkSubjectMismatchError(
                          record.get('subject')?.value
                        ) && !isError('irs', record)
                      "
                      class="error-label"
                    >
                      The SS# values for record subject
                      {{ record.get("subject")?.value }} should match
                    </small>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="checkRecordType(record, 'union')">
              <div formGroupName="union">
                <label class="form-label d-block">Union</label>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label for="membership-number" class="form-label d-block"
                      >Membership Number (if known)</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="membership-number"
                      class="w-100"
                      placeholder="Enter membership number"
                      formControlName="membershipNumber"
                    />
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="checkRecordType(record, 'other')">
              <div formGroupName="other">
                <label class="form-label d-block">Other</label>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <label
                      for="description-of-records"
                      class="form-label d-block required-asterisk"
                      >Description of Records</label
                    >
                    <input
                      pInputText
                      type="text"
                      id="description-of-records"
                      class="w-100"
                      placeholder="Enter other"
                      formControlName="descriptionOfRecords"
                      [ngClass]="{
                        'ng-invalid ng-dirty': isError('other', record)
                      }"
                    />
                    <small
                      id="descriptionOfRecords-error"
                      *ngIf="isError('other', record)"
                      class="error-label"
                      >This field is mandatory</small
                    >
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="checkRecordType(record, 'va')">
              <div formGroupName="va">
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                    <p-checkbox
                      value="medical-records"
                      id="medical-records"
                      formControlName="medical"
                      inputId="medical-records-label"
                    />
                    <label for="medical-records-label" class="ms-2 mt-2"
                      >Medical Records</label
                    >
                  </div>
                  <div class="col-sm-2 mb-3 mb-sm-0">
                    <p-checkbox
                      value="benefit-records"
                      id="benefit-records"
                      formControlName="benefit"
                      inputId="benefit-records-label"
                    />
                    <label for="benefit-records-label" class="ms-2 mt-2"
                      >Benefit Records</label
                    >
                  </div>
                </div>
              </div>
            </ng-container>
          </p-card>
        </ng-container>
        <div
          class="row mb-3"
          *ngIf="selectedCategory === 'Subpoena to be prepared by EXL'"
        >
          <div class="col-sm-12">
            <label for="record-subpoena-language" class="form-label d-block"
              >Subpoena Language</label
            >
            <textarea
              class="w-100"
              pTextarea
              id="record-subpoena-language-textarea"
              placeholder="Enter subpoena language"
              formControlName="subpoenaLanguageTextarea"
            ></textarea>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-12">
            <label for="record-notes" class="form-label d-block">Notes</label>
            <textarea
              class="w-100"
              pTextarea
              id="record-notes-textarea"
              placeholder="Enter text here"
              formControlName="notesTextarea"
            ></textarea>
          </div>
        </div>
            <!-- Code Implementation for Attachments -->
            <div class="row mb-3 record-attachments-container">
              <div class="col-sm-12">
                <app-attachments [attachments]="attachments" [editOrder]="false" [attachmentForm]="record" [parentId]="'Add'"
                  [instructionText]="'Upload all request-level attachments (e.g. authorization, subpoena etc.)'"
                  [instructionText2]="'Ensure each uploaded file is under 100 MB and in an accepted format, such as PDF, Excel (XLS/XLSX), CSV, or Word (DOC/DOCX).'"
                  [headerStyleClass]="'panel-without-border'"
                  [documentType]="'RequestDocumentCode'">
                </app-attachments>
              </div>
            </div>
        <div class="d-flex justify-content-end">
          <p-button
            id="add-provider-cancel-button"
            severity="secondary"
            label="Cancel"
            (onClick)="onCancel()"
            class="ms-3"
          />
          <p-button
            id="add-provider-save-button"
            label="Save"
            (onClick)="onSave()"
            class="ms-3"
          />
        </div>
      </div>
    </p-panel>
  </div>
</form>
<p-toast position="top-center" />
